import { Navigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

import { useAuth } from "../contexts/UserContext";
import { ONBOARDING_PATH } from "../config/navigation";

const DATA_ENTRY_HOME = "/emission/add";

const DATA_ENTRY_ALLOWED_PATHS = [
  DATA_ENTRY_HOME,
  "/account/profile",
  "/account",
  "/select-organization",
  // The wizard refuses ineligible callers with its own message; a redirect would hide why.
  ONBOARDING_PATH,
];

const ProtectedRoutes = ({ children }: { children: any }) => {
  const { isAuthenticated, user, isDataEntry, isInitialized } = useAuth();
  const location = useLocation();

  // --- Loading / Auth Guards ---
  if (!isInitialized) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Redirect before rendering: a page Data Entry can't use would otherwise fire its data calls first.
  if (
    user &&
    !DATA_ENTRY_ALLOWED_PATHS.includes(location.pathname) &&
    isDataEntry()
  ) {
    return <Navigate to={DATA_ENTRY_HOME} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoutes;
